module.exports = __webpack_public_path__ + "img/kws.ce9666e1.svg";